import { useRef } from 'react'

import { useOnScreen } from '../../../../hooks'

export function useTableEdgesIntersection() {
  const leftEndIntersectionRef = useRef(null)
  const rightEndIntersectionRef = useRef(null)

  const isIntersectingLeftEnd = useOnScreen({ ref: leftEndIntersectionRef })
  const isIntersectingRightEnd = useOnScreen({ ref: rightEndIntersectionRef })

  return {
    isIntersectingLeftEnd,
    isIntersectingRightEnd,
    leftEndIntersectionRef,
    rightEndIntersectionRef,
  }
}
